import React, { ReactElement, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AppLayout from './AppLayout';
import { Home, Contact, NotFoundPage, About, Work } from '../views';

// Lazy load heavy components
const MultiClip = lazy(() =>
  import('../views/multiclip/multiclip').then((m) => ({ default: m.default })),
);
const MdGenerator = lazy(() =>
  import('../views/md-generator/md-generator').then((m) => ({
    default: m.default,
  })),
);
const ReactBirdFlockDocs = lazy(() =>
  import('../views/react-bird-flock/react-bird-flock').then((m) => ({
    default: m.default,
  })),
);

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>
);

// setup browser router for url routing
const AppRoutes: React.FC = (): ReactElement => (
  <BrowserRouter>
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<Home />} />
        <Route path="contact" element={<Contact />} />
        <Route path="about" element={<About />} />
        <Route path="work" element={<Work />} />
        <Route
          path="multiclip"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <MultiClip />
            </Suspense>
          }
        />
        <Route
          path="md-generator"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <MdGenerator />
            </Suspense>
          }
        />
        <Route
          path="react-bird-flock"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <ReactBirdFlockDocs />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
